import { useEffect, useState } from 'react';

export function AnimatedStat({ value, suffix, color, fluctuate }: { value: number; suffix: string; color: string; fluctuate?: { min: number; max: number } }) {
  const [display, setDisplay] = useState(value);

  useEffect(() => {
    if (!fluctuate) return undefined;
    let timer: ReturnType<typeof setTimeout>;
    const tick = () => {
      setDisplay(Math.round(fluctuate.min + Math.random() * (fluctuate.max - fluctuate.min)));
      timer = setTimeout(tick, 500 + Math.random() * 300);
    };
    timer = setTimeout(tick, 500 + Math.random() * 300);
    return () => clearTimeout(timer);
  }, [fluctuate]);

  return (
    <span className='font-bold tabular-nums' style={{ color, fontFamily: 'var(--font-jetbrains)' }}>
      {display}
      {suffix}
    </span>
  );
}
